/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';
import { requestWorkroomList } from 'actionCreators';
import { getWorkroomList, getWorkroomLoaded } from '../../../../reducers';
import ReactSelect from 'components/StyledSelect/react_select';
import { generateSource } from '../../../../utils';
import reactSelectStyles from 'components/ReactSelect/styles';

class WorkroomSelect extends Component {
  componentDidMount = () => {
    if (!this.props.loaded) this.props.requestWorkroomList();
  }

  getOptions = () => {
    const { options, value = [], oneRequired } = this.props;
    if (oneRequired && value.length === 1) {
      return this.props.options.map(o => ({
        ...o, clearableValue: o.value !== value[0],
      }));
    }
    return options;
  }

  render = () => {
    const { className, loaded, oneRequired, multi, ...props } = this.props;
    return (<ReactSelect
      {...props}
      multi
      resetValue={[]}
      name="workroom"
      className={cx(reactSelectStyles, className)}
      label={multi ? 'Workrooms' : 'Workroom'}
      placeholder="All Workrooms"
      options={this.getOptions()}
      clearable={!oneRequired}
    />);
  }
}

WorkroomSelect.defaultProps = {
  oneRequired: false,
  multi: true,
};

WorkroomSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number,
    PropTypes.array,
  ]),
  className: PropTypes.string,
  loaded: PropTypes.bool.isRequired,
  requestWorkroomList: PropTypes.func.isRequired,
  oneRequired: PropTypes.bool,
  multi: PropTypes.bool,
};

const getWorkroomOptions = createSelector(getWorkroomList,
  workrooms => generateSource(workrooms));

export default connect(state => ({
  loaded: getWorkroomLoaded(state),
  options: getWorkroomOptions(state),
}), { requestWorkroomList })(WorkroomSelect);



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/WorkroomSelect/index.jsx